import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "providerModal",
  ref: "modalEl",
  class: "modal fade",
  tabindex: "-1",
  "aria-labelledby": "providerModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  id: "providerModalLabel",
  class: "modal-title"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "dp-driver",
  role: "note"
}
const _hoisted_7 = { class: "dp-section" }
const _hoisted_8 = { class: "row g-3" }
const _hoisted_9 = { class: "col-md-5 sx-field" }
const _hoisted_10 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_11 = { class: "col-md-4 sx-field" }
const _hoisted_12 = { class: "col-md-3 sx-field" }
const _hoisted_13 = { class: "form-check form-switch dp-switch" }
const _hoisted_14 = {
  class: "form-check-label",
  for: "dp-active"
}
const _hoisted_15 = { class: "dp-section" }
const _hoisted_16 = { class: "row g-3" }
const _hoisted_17 = { class: "col-md-6 sx-field" }
const _hoisted_18 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_19 = { class: "col-md-6 sx-field" }
const _hoisted_20 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_21 = {
  key: 1,
  class: "sx-help",
  textContent: 'Relatif à l\'URL de l\'API, ou URL complète. Variables possibles : {{token}}, {{username}}, {{extra.cle}} (ex. /customers/{{extra.client_id}}/{{token}}/add-parcel).'
}
const _hoisted_22 = { class: "col-md-4 sx-field" }
const _hoisted_23 = { class: "col-md-4 sx-field" }
const _hoisted_24 = { class: "col-md-4 sx-field" }
const _hoisted_25 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_26 = { class: "dp-section" }
const _hoisted_27 = {
  class: "sx-seg dp-seg",
  role: "radiogroup",
  "aria-label": "Type d'authentification"
}
const _hoisted_28 = ["aria-checked", "onClick"]
const _hoisted_29 = { class: "sx-help dp-auth-help" }
const _hoisted_30 = { class: "row g-3" }
const _hoisted_31 = {
  key: 0,
  class: "col-md-6 sx-field"
}
const _hoisted_32 = { for: "dp-keyname" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_35 = {
  key: 1,
  class: "col-md-6 sx-field"
}
const _hoisted_36 = { for: "dp-token" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { class: "sx-help" }
const _hoisted_39 = {
  key: 2,
  class: "col-md-6 sx-field"
}
const _hoisted_40 = { for: "dp-user" }
const _hoisted_41 = {
  key: 0,
  class: "sx-req",
  "aria-hidden": "true"
}
const _hoisted_42 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_43 = {
  key: 3,
  class: "col-md-6 sx-field"
}
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = { class: "sx-help" }
const _hoisted_46 = { class: "col-md-6 sx-field" }
const _hoisted_47 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_48 = { class: "col-md-6 sx-field" }
const _hoisted_49 = { class: "col-12 sx-field" }
const _hoisted_50 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_51 = {
  key: 1,
  class: "sx-help"
}
const _hoisted_52 = { class: "dp-section" }
const _hoisted_53 = { class: "row g-3" }
const _hoisted_54 = { class: "col-lg-8 sx-field" }
const _hoisted_55 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_56 = {
  key: 1,
  class: "sx-err"
}
const _hoisted_57 = {
  key: 2,
  class: "sx-help"
}
const _hoisted_58 = { class: "col-lg-4" }
const _hoisted_59 = { class: "dp-vars" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "dp-preview" }
const _hoisted_62 = { class: "dp-preview-bar" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_65 = {
  key: 1,
  class: "ph ph-eye",
  "aria-hidden": "true"
}
const _hoisted_66 = {
  key: 0,
  class: "dp-preview-out"
}
const _hoisted_67 = { class: "dp-section" }
const _hoisted_68 = { class: "row g-2 mb-2" }
const _hoisted_69 = { class: "col-md-12 sx-field" }
const _hoisted_70 = { class: "col-md-4 sx-field" }
const _hoisted_71 = { class: "col-md-4 sx-field" }
const _hoisted_72 = { class: "col-md-4 sx-field" }
const _hoisted_73 = { class: "col-12 d-flex flex-wrap align-items-center gap-2" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = {
  key: 0,
  class: "sx-help"
}
const _hoisted_76 = { class: "dp-cities-bar" }
const _hoisted_77 = { class: "sx-help" }
const _hoisted_78 = { class: "dp-cities" }
const _hoisted_79 = ["for"]
const _hoisted_80 = ["id", "onUpdate:modelValue"]
const _hoisted_81 = {
  key: 0,
  class: "sx-help"
}
const _hoisted_82 = { class: "dp-section" }
const _hoisted_83 = { class: "row g-3" }
const _hoisted_84 = { class: "col-md-6 sx-field" }
const _hoisted_85 = { class: "col-md-6 sx-field" }
const _hoisted_86 = { class: "col-md-6 sx-field" }
const _hoisted_87 = { class: "col-md-6 sx-field" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "dp-section" }
const _hoisted_90 = { class: "row g-3" }
const _hoisted_91 = { class: "col-md-6 sx-field" }
const _hoisted_92 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_93 = { class: "col-md-6 sx-field" }
const _hoisted_94 = {
  key: 0,
  class: "sx-err"
}
const _hoisted_95 = {
  key: 1,
  class: "sx-help"
}
const _hoisted_96 = { class: "modal-footer" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "modal-content",
        novalidate: "",
        onSubmit: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _cache[33] || (_cache[33] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.form.user_id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[35] || (_cache[35] = _createElementVNode("i", {
                  class: "ph ph-moped",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, "Livreur prestataire : " + _toDisplayString(_ctx.driverName || _ctx.form.name), 1),
                  _cache[34] || (_cache[34] = _createElementVNode("span", null, " Il reste un livreur (compte, frais, villes). À l'expédition d'un bon d'envoi vers ce prestataire, les colis sont envoyés à son API puis un bon de distribution est créé automatiquement à son nom. ", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("fieldset", _hoisted_7, [
            _cache[39] || (_cache[39] = _createElementVNode("legend", null, "Général", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { for: "dp-name" }, [
                  _createTextVNode("Nom "),
                  _createElementVNode("span", {
                    class: "sx-req",
                    "aria-hidden": "true"
                  }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.name }]),
                  maxlength: "100",
                  placeholder: "Ex. Sendit"
                }, null, 2), [
                  [_vModelText, _ctx.form.name]
                ]),
                (_ctx.errors.name)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.errors.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { for: "dp-code" }, "Code", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-code",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.code) = $event)),
                  type: "text",
                  class: "form-control",
                  maxlength: "50",
                  placeholder: "Ex. SND"
                }, null, 512), [
                  [_vModelText, _ctx.form.code]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { for: "dp-active" }, "Statut", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    id: "dp-active",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.active) = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.active]
                  ]),
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.form.active ? "Actif" : "Inactif"), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_15, [
            _cache[47] || (_cache[47] = _createElementVNode("legend", null, "Connexion", -1)),
            _cache[48] || (_cache[48] = _createElementVNode("p", { class: "sx-help dp-auth-help" }, " Facultatif à la création. Tant que l'URL et l'endpoint ne sont pas renseignés, le prestataire n'est pas proposé à l'expédition. ", -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { for: "dp-url" }, "URL de l'API", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-url",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.api_base_url) = $event)),
                  type: "url",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.api_base_url }]),
                  placeholder: "https://api.prestataire.ma/v1"
                }, null, 2), [
                  [_vModelText, _ctx.form.api_base_url]
                ]),
                (_ctx.errors.api_base_url)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.errors.api_base_url), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { for: "dp-endpoint" }, "Endpoint d'ajout de colis", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-endpoint",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.api_create_endpoint) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.api_create_endpoint }]),
                  placeholder: "/parcels"
                }, null, 2), [
                  [_vModelText, _ctx.form.api_create_endpoint]
                ]),
                (_ctx.errors.api_create_endpoint)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.errors.api_create_endpoint), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21))
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[43] || (_cache[43] = _createElementVNode("label", { for: "dp-method" }, "Méthode", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "dp-method",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.api_method) = $event)),
                  class: "form-select"
                }, _cache[42] || (_cache[42] = [
                  _createElementVNode("option", null, "GET", -1),
                  _createElementVNode("option", null, "POST", -1),
                  _createElementVNode("option", null, "PUT", -1),
                  _createElementVNode("option", null, "PATCH", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.api_method]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { for: "dp-format" }, "Format du corps", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "dp-format",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.api_body_format) = $event)),
                  class: "form-select"
                }, _cache[44] || (_cache[44] = [
                  _createElementVNode("option", { value: "json" }, "JSON", -1),
                  _createElementVNode("option", { value: "form" }, "Formulaire (x-www-form-urlencoded)", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.form.api_body_format]
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[46] || (_cache[46] = _createElementVNode("label", { for: "dp-timeout" }, "Délai d'attente (s)", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-timeout",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.api_timeout) = $event)),
                  type: "number",
                  min: "5",
                  max: "120",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.api_timeout }])
                }, null, 2), [
                  [
                    _vModelText,
                    _ctx.form.api_timeout,
                    void 0,
                    { number: true }
                  ]
                ]),
                (_ctx.errors.api_timeout)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.errors.api_timeout), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_26, [
            _cache[58] || (_cache[58] = _createElementVNode("legend", null, "Authentification", -1)),
            _createElementVNode("div", _hoisted_27, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authOptions, (opt) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: opt.value,
                  type: "button",
                  role: "radio",
                  "aria-checked": _ctx.form.api_auth_type === opt.value,
                  class: _normalizeClass({ 'is-active': _ctx.form.api_auth_type === opt.value }),
                  onClick: ($event: any) => (_ctx.form.api_auth_type = opt.value)
                }, _toDisplayString(opt.label), 11, _hoisted_28))
              }), 128))
            ]),
            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.authOf(_ctx.form.api_auth_type)?.help), 1),
            _createElementVNode("div", _hoisted_30, [
              (['header', 'query'].includes(_ctx.form.api_auth_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_ctx.form.api_auth_type === "header" ? "Nom de l'en-tête" : "Nom du paramètre") + " ", 1),
                      _cache[49] || (_cache[49] = _createElementVNode("span", {
                        class: "sx-req",
                        "aria-hidden": "true"
                      }, "*", -1))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "dp-keyname",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.api_key_name) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.api_key_name }]),
                      placeholder: _ctx.form.api_auth_type === 'header' ? 'X-API-KEY' : 'api_key'
                    }, null, 10, _hoisted_33), [
                      [_vModelText, _ctx.form.api_key_name]
                    ]),
                    (_ctx.errors.api_key_name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.errors.api_key_name), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (['bearer', 'header', 'query', 'login', 'url'].includes(_ctx.form.api_auth_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("label", _hoisted_36, [
                      _cache[50] || (_cache[50] = _createTextVNode("Clé / token", -1)),
                      (_ctx.form.api_auth_type === 'login')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" (facultatif)")
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "dp-token",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.api_token) = $event)),
                      type: "password",
                      class: "form-control",
                      autocomplete: "new-password",
                      placeholder: _ctx.form.api_token_hint || 'Coller la clé'
                    }, null, 8, _hoisted_37), [
                      [_vModelText, _ctx.form.api_token]
                    ]),
                    _createElementVNode("span", _hoisted_38, [
                      (_ctx.form.api_token_set)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Enregistré (" + _toDisplayString(_ctx.form.api_token_hint) + "). Laisser vide pour le conserver. ", 1),
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.form.clear_token = !_ctx.form.clear_token), ["prevent"]))
                            }, _toDisplayString(_ctx.form.clear_token ? "Annuler la suppression" : "Supprimer"), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Stocké chiffré, jamais réaffiché.")
                          ], 64))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (['basic', 'login'].includes(_ctx.form.api_auth_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("label", _hoisted_40, [
                      _cache[51] || (_cache[51] = _createTextVNode("Identifiant ", -1)),
                      (_ctx.form.api_auth_type === 'basic')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "dp-user",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.api_username) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.api_username }]),
                      autocomplete: "off"
                    }, null, 2), [
                      [_vModelText, _ctx.form.api_username]
                    ]),
                    (_ctx.errors.api_username)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.errors.api_username), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (['basic', 'login'].includes(_ctx.form.api_auth_type))
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _cache[53] || (_cache[53] = _createElementVNode("label", { for: "dp-pass" }, "Mot de passe / secret", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "dp-pass",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.api_password) = $event)),
                      type: "password",
                      class: "form-control",
                      autocomplete: "new-password",
                      placeholder: _ctx.form.api_password_set ? '••••••••' : ''
                    }, null, 8, _hoisted_44), [
                      [_vModelText, _ctx.form.api_password]
                    ]),
                    _createElementVNode("span", _hoisted_45, [
                      (_ctx.form.api_password_set)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[52] || (_cache[52] = _createTextVNode("Enregistré. Laisser vide pour le conserver. ", -1)),
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.form.clear_password = !_ctx.form.clear_password), ["prevent"]))
                            }, _toDisplayString(_ctx.form.clear_password ? "Annuler la suppression" : "Supprimer"), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Stocké chiffré, jamais réaffiché.")
                          ], 64))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.api_auth_type === 'login')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[54] || (_cache[54] = _createElementVNode("label", { for: "dp-authep" }, [
                        _createTextVNode("Endpoint d'authentification "),
                        _createElementVNode("span", {
                          class: "sx-req",
                          "aria-hidden": "true"
                        }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "dp-authep",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.api_auth_endpoint) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.api_auth_endpoint }]),
                        placeholder: "/login"
                      }, null, 2), [
                        [_vModelText, _ctx.form.api_auth_endpoint]
                      ]),
                      (_ctx.errors.api_auth_endpoint)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.errors.api_auth_endpoint), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _cache[55] || (_cache[55] = _createElementVNode("label", { for: "dp-authpath" }, "Chemin du token dans la réponse", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "dp-authpath",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.api_auth_token_path) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: "data.token"
                      }, null, 512), [
                        [_vModelText, _ctx.form.api_auth_token_path]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _cache[57] || (_cache[57] = _createElementVNode("label", { for: "dp-authbody" }, "Corps de la requête d'authentification (JSON)", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        id: "dp-authbody",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.api_auth_payload) = $event)),
                        class: _normalizeClass(["form-control dp-code", { 'is-invalid': _ctx.errors.api_auth_payload }]),
                        rows: "3",
                        spellcheck: "false",
                        placeholder: "{\"public_key\": \"{{username}}\", \"secret_key\": \"{{password}}\"}"
                      }, null, 2), [
                        [_vModelText, _ctx.form.api_auth_payload]
                      ]),
                      (_ctx.errors.api_auth_payload)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.errors.api_auth_payload), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_51, _cache[56] || (_cache[56] = [
                            _createTextVNode("Variables : ", -1),
                            _createElementVNode("code", { textContent: '{{username}}' }, null, -1),
                            _createTextVNode(", ", -1),
                            _createElementVNode("code", { textContent: '{{password}}' }, null, -1),
                            _createTextVNode(", ", -1),
                            _createElementVNode("code", { textContent: '{{token}}' }, null, -1),
                            _createTextVNode(", ", -1),
                            _createElementVNode("code", { textContent: '{{extra.*}}' }, null, -1),
                            _createTextVNode(". Le token obtenu est envoyé en Bearer et gardé 50 min.", -1)
                          ])))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_52, [
            _cache[64] || (_cache[64] = _createElementVNode("legend", null, "Données envoyées pour chaque colis", -1)),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _cache[59] || (_cache[59] = _createElementVNode("label", { for: "dp-payload" }, [
                  _createTextVNode("Modèle JSON "),
                  _createElementVNode("span", {
                    class: "sx-req",
                    "aria-hidden": "true"
                  }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "dp-payload",
                  ref: "payloadEl",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.api_payload_template) = $event)),
                  class: _normalizeClass(["form-control dp-code", { 'is-invalid': _ctx.errors.api_payload_template || _ctx.payloadJsonError }]),
                  rows: "14",
                  spellcheck: "false"
                }, null, 2), [
                  [_vModelText, _ctx.form.api_payload_template]
                ]),
                (_ctx.errors.api_payload_template)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.errors.api_payload_template), 1))
                  : (_ctx.payloadJsonError)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.payloadJsonError), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_57, " Une valeur égale à une seule variable garde son type (nombre, booléen) ; sinon les variables sont insérées dans le texte. "))
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _cache[60] || (_cache[60] = _createElementVNode("strong", null, "Variables", -1)),
                  _cache[61] || (_cache[61] = _createElementVNode("p", { class: "sx-help" }, "Cliquer pour insérer au curseur.", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variableGroups, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.label,
                      class: "dp-vars-group"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(group.label), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (v) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: v,
                          type: "button",
                          class: "dp-chip",
                          onClick: ($event: any) => (_ctx.insertVariable(v))
                        }, _toDisplayString(v), 9, _hoisted_60))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.previewCode) = $event)),
                  type: "text",
                  class: "form-control form-control-sm",
                  placeholder: "Code colis (facultatif)",
                  "aria-label": "Code colis pour l'aperçu"
                }, null, 512), [
                  [_vModelText, _ctx.previewCode]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary",
                  disabled: _ctx.previewing,
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.runPreview && _ctx.runPreview(...args)))
                }, [
                  (_ctx.previewing)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                    : (_openBlock(), _createElementBlock("i", _hoisted_65)),
                  _cache[62] || (_cache[62] = _createTextVNode(" Aperçu ", -1))
                ], 8, _hoisted_63),
                _cache[63] || (_cache[63] = _createElementVNode("span", { class: "sx-help" }, "Rien n'est envoyé au prestataire.", -1))
              ]),
              (_ctx.preview)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("small", null, _toDisplayString(_ctx.form.api_method) + " " + _toDisplayString(_ctx.preview.url) + " — colis " + _toDisplayString(_ctx.preview.coli_code), 1),
                    _createElementVNode("pre", null, _toDisplayString(_ctx.pretty(_ctx.preview.payload)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_67, [
            _cache[69] || (_cache[69] = _createElementVNode("legend", null, "Villes du prestataire", -1)),
            _cache[70] || (_cache[70] = _createElementVNode("p", { class: "sx-help dp-auth-help" }, [
              _createTextVNode(" Saisissez l'ID de chaque ville dans la liste des villes du prestataire, puis utilisez la variable "),
              _createElementVNode("code", { textContent: '{{coli.provider_city_id}}' }),
              _createTextVNode(" dans le modèle (ex. "),
              _createElementVNode("code", { textContent: '"parcel-city": "{{coli.provider_city_id}}"' }),
              _createTextVNode("). Un colis dont la ville n'a pas d'ID n'est pas envoyé. ")
            ], -1)),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _cache[65] || (_cache[65] = _createElementVNode("label", { for: "dp-cities-endpoint" }, "URL de la liste des villes du prestataire", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-cities-endpoint",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.api_cities_endpoint) = $event)),
                  type: "text",
                  class: "form-control form-control-sm",
                  placeholder: "https://api.prestataire.com/cities"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_cities_endpoint]
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _cache[66] || (_cache[66] = _createElementVNode("label", { for: "dp-cities-list" }, "Chemin de la liste", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-cities-list",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.api_cities_list_path) = $event)),
                  type: "text",
                  class: "form-control form-control-sm",
                  placeholder: "data (vide = racine)"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_cities_list_path]
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _cache[67] || (_cache[67] = _createElementVNode("label", { for: "dp-cities-id" }, "Clé de l'ID", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-cities-id",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.api_cities_id_path) = $event)),
                  type: "text",
                  class: "form-control form-control-sm",
                  placeholder: "id"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_cities_id_path]
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _cache[68] || (_cache[68] = _createElementVNode("label", { for: "dp-cities-name" }, "Clé du nom", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-cities-name",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.api_cities_name_path) = $event)),
                  type: "text",
                  class: "form-control form-control-sm",
                  placeholder: "name"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_cities_name_path]
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary",
                  disabled: _ctx.importingCities,
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.importCities && _ctx.importCities(...args)))
                }, _toDisplayString(_ctx.importingCities ? "Import en cours…" : "Importer les villes (association par nom)"), 9, _hoisted_74),
                (_ctx.importResult)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(_ctx.importResult), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.cityQuery) = $event)),
                type: "search",
                class: "form-control form-control-sm",
                placeholder: "Rechercher une ville",
                "aria-label": "Rechercher une ville"
              }, null, 512), [
                [_vModelText, _ctx.cityQuery]
              ]),
              _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.mappedCount) + " / " + _toDisplayString(_ctx.cities.length) + " ville(s) renseignée(s)", 1)
            ]),
            _createElementVNode("div", _hoisted_78, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCities, (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: c.id,
                  class: "dp-city"
                }, [
                  _createElementVNode("label", {
                    for: 'dp-city-' + c.id
                  }, _toDisplayString(c.name), 9, _hoisted_79),
                  _withDirectives(_createElementVNode("input", {
                    id: 'dp-city-' + c.id,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.cityMap[c.id]) = $event),
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: "ID prestataire"
                  }, null, 8, _hoisted_80), [
                    [
                      _vModelText,
                      _ctx.cityMap[c.id],
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]))
              }), 128)),
              (!_ctx.filteredCities.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_81, "Aucune ville."))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_82, [
            _cache[78] || (_cache[78] = _createElementVNode("legend", null, "Lecture de la réponse", -1)),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _cache[71] || (_cache[71] = _createElementVNode("label", { for: "dp-tracking" }, "Chemin du numéro de suivi", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-tracking",
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.api_tracking_path) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "data.tracking_number"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_tracking_path]
                ]),
                _cache[72] || (_cache[72] = _createElementVNode("span", { class: "sx-help" }, [
                  _createTextVNode("Notation pointée, ex. "),
                  _createElementVNode("code", null, "data.0.code"),
                  _createTextVNode(".")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_85, [
                _cache[73] || (_cache[73] = _createElementVNode("label", { for: "dp-error" }, "Chemin du message d'erreur", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-error",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.api_error_path) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "message"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_error_path]
                ])
              ]),
              _createElementVNode("div", _hoisted_86, [
                _cache[74] || (_cache[74] = _createElementVNode("label", { for: "dp-successpath" }, "Chemin de l'indicateur de succès", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-successpath",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.api_success_path) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "success"
                }, null, 512), [
                  [_vModelText, _ctx.form.api_success_path]
                ]),
                _cache[75] || (_cache[75] = _createElementVNode("span", { class: "sx-help" }, "Vide : tout code HTTP 2xx est un succès.", -1))
              ]),
              _createElementVNode("div", _hoisted_87, [
                _cache[76] || (_cache[76] = _createElementVNode("label", { for: "dp-successval" }, "Valeur attendue", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "dp-successval",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.api_success_value) = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "true",
                  disabled: !_ctx.form.api_success_path
                }, null, 8, _hoisted_88), [
                  [_vModelText, _ctx.form.api_success_value]
                ]),
                _cache[77] || (_cache[77] = _createElementVNode("span", { class: "sx-help" }, "Vide : la valeur doit simplement être vraie.", -1))
              ])
            ])
          ]),
          _createElementVNode("fieldset", _hoisted_89, [
            _cache[82] || (_cache[82] = _createElementVNode("legend", null, "Paramètres spécifiques", -1)),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _cache[79] || (_cache[79] = _createElementVNode("label", { for: "dp-headers" }, "En-têtes supplémentaires (JSON)", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "dp-headers",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.api_headers) = $event)),
                  class: _normalizeClass(["form-control dp-code", { 'is-invalid': _ctx.errors.api_headers }]),
                  rows: "4",
                  spellcheck: "false",
                  placeholder: "{\"X-Account\": \"123\"}"
                }, null, 2), [
                  [_vModelText, _ctx.form.api_headers]
                ]),
                (_ctx.errors.api_headers)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(_ctx.errors.api_headers), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_93, [
                _cache[81] || (_cache[81] = _createElementVNode("label", { for: "dp-extra" }, "Autres paramètres (JSON)", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  id: "dp-extra",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.api_extra) = $event)),
                  class: _normalizeClass(["form-control dp-code", { 'is-invalid': _ctx.errors.api_extra }]),
                  rows: "4",
                  spellcheck: "false",
                  placeholder: "{\"store_id\": 42, \"service\": \"express\"}"
                }, null, 2), [
                  [_vModelText, _ctx.form.api_extra]
                ]),
                (_ctx.errors.api_extra)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(_ctx.errors.api_extra), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_95, _cache[80] || (_cache[80] = [
                      _createTextVNode("Utilisables dans le modèle via ", -1),
                      _createElementVNode("code", { textContent: '{{extra.store_id}}' }, null, -1),
                      _createTextVNode(".", -1)
                    ])))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _cache[84] || (_cache[84] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-light",
            "data-bs-dismiss": "modal"
          }, "Annuler", -1)),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            disabled: _ctx.saving
          }, [
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_98))
              : _createCommentVNode("", true),
            _cache[83] || (_cache[83] = _createTextVNode(" Enregistrer ", -1))
          ], 8, _hoisted_97)
        ])
      ], 32)
    ])
  ], 512))
}